import React from 'react';

const LANGUAGE_SHORT = {
  en: 'EN', es: 'ES', fr: 'FR',
  hi: 'हि', kn: 'ಕ', mr: 'मर',
  ml: 'മ', ta: 'த', te: 'తె',
};

export function LanguageBadge({ code }) {
  if (!code) {
    return (
      <span
        className="text-xs text-amber-600 font-medium ml-1"
        title="No language set — will default to English"
        aria-label="No WhatsApp language set"
      >
        ⚠
      </span>
    );
  }
  const short = LANGUAGE_SHORT[code] ?? code.toUpperCase();
  return (
    <span
      className="text-xs text-gray-500 font-medium ml-1 px-1 py-0.5 rounded bg-gray-100"
      title={`WhatsApp messages in ${code}`}
    >
      {short}
    </span>
  );
}